module.exports = __webpack_public_path__ + "img/icon_vip_priority loan@3x(3).7c5d4c71.png";